import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=c0b5c010&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=c0b5c010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b5c010",
  null
  
)

export default component.exports